//Flashcards
export const GET_FLASHCARD_DETAILS = "GET_FLASHCARD_DETAILS";

//Fast Quiz
export const GET_FAST_QUIZ_QUESTIONS = "GET_FAST_QUIZ_QUESTIONS";

//Score Report
export const SAVE_SCORE_REPORT_DETAILS = "SAVE_SCORE_REPORT_DETAILS";
export const POST_TEST_SCORE_TO_SERVER = "POST_TEST_SCORE_TO_SERVER";
export const SAVE_TEST_USER_DETAILS = "SAVE_TEST_USER_DETAILS";
export const GET_SCORE_FEEDBACK = "GET_SCORE_FEEDBACK";

//Question set details
export const GET_QUESTION_SET_DETAILS = "GET_QUESTION_SET_DETAILS";
